module.exports = __webpack_public_path__ + "static/media/arrow-rht_icon.f54a903d.png";